import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  InputType,
  ValidationRule,
} from "../services/types/ComponentTypes";

export const screen_137_head_name_add: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    title: "Subgroup",
    style: {
      backgroundColor: "#F9FAFB",

    },
    childComponents: [
      {
        componentType: LayoutTypes.GROUP,
        style: {
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
          borderRadius: 12,
          padding: 16,
        },
        childComponents: [
          {
            componentType: LayoutTypes.GROUP,
            Label: "",
            BindValue: "cont_Action",
            style: {
              direction: FlexDirection.ROW,
              padding: 0,
              margin: 0,
              marginBottom: 8,
            },
            childComponents: [],
          },
          {
            componentType: LayoutTypes.FORM,
            Name: "sub_head_group_add",
            TableName: "ledger_group",
            DisplayName: "Subgroup",
            columnNumber: "m1 t1 w3",
            style: {
              padding: 10,
              backgroundColor: "#ffffff",
              direction: FlexDirection.COLUMN,
            },
            childComponents: [
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_name",
                label: "Head Name",
                placeholder: "Enter Head Name",
                required: true,
                inputType: InputType.TEXT,
                Json_Attribute: "group_name",
                IsVerticalView: true,
                validation: [
                  {
                    rule: ValidationRule.REQUIRED,
                    message: "Head Name is required",
                  },
                ],
              },

              {
                componentType: LayoutTypes.GROUP,
                style: {
                  direction: FlexDirection.ROW,
                  padding: 16,
                  gap: 12,
                  margin: 22,

                },
                childComponents: [
                  {
                    componentType: ComponentType.BUTTON,
                    name: "Submit",
                    Label: "Submit",
                    BindValue: "btn_submit",
                    onPressAction: "save",
                    ActionType: "Add",
                    ScreenId: "137",
                    style: {
                      backgroundColor: "#22C55E",
                      textColor: "#FFFFFF",
                      padding: 12,
                      borderRadius: 6,


                    },
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
];



